export default __webpack_public_path__ + "static/media/featured-nasdaq.29210e5f.webp";